function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M17.6309 7.86166C18.1386 7.54785 18.2957 6.88189 17.9819 6.37418C17.6681 5.86648 17.0022 5.7093 16.4945 6.02311C15.9868 6.33692 15.8296 7.00288 16.1434 7.51059C16.4572 8.01829 17.1232 8.17547 17.6309 7.86166Z",
  fill: "currentColor"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M1.32411 19.665C-0.35922 21.3484 0.041749 23.9575 0.041749 23.9575C0.041749 23.9575 2.6509 24.3585 4.33423 22.6751C5.2961 21.7793 5.48023 20.4915 4.51254 19.4867C3.52193 18.4874 2.13833 18.7576 1.32411 19.665V19.665Z",
  fill: "currentColor"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M23.9869 0.0137298C23.3583 -0.022364 22.1686 -0.00642649 20.6016 0.3967C18.4064 0.961077 15.001 2.42311 11.2434 6.18109C8.99672 8.42735 7.54828 10.5569 6.25171 12.8121L8.22187 14.7822L8.98313 14.0205L9.97876 15.0161L9.2175 15.7774L11.1872 17.7475C13.4428 16.451 15.5719 15.0025 17.8182 12.7563C23.8346 6.73984 24.0797 1.5967 23.9869 0.0137298V0.0137298ZM14.5599 6.94469C14.5599 5.56469 15.6769 4.44624 17.055 4.44624C18.4327 4.44624 19.5497 5.56469 19.5497 6.94469C19.5497 8.32469 18.4327 9.4436 17.055 9.4436C15.6769 9.4436 14.5599 8.32469 14.5599 6.94469Z",
  fill: "currentColor"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M7.46054 17.5343L6.46515 16.5389L7.22654 15.7775L5.53791 14.0889C5.23576 14.6421 4.49119 16.0376 4.42224 16.1667L7.83268 19.5771C7.96168 19.5083 9.35719 18.7637 9.91055 18.4615L8.22193 16.7729L7.46054 17.5343Z",
  fill: "currentColor"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M13.5645 20.2697V22.7282L14.7937 23.9574L17.2522 21.4989L18.7987 13.7661C16.5179 16.044 14.376 17.5243 12.1265 18.8317L13.5645 20.2697Z",
  fill: "currentColor"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M3.72941 10.4349L5.16748 11.873C6.47492 9.62334 7.95509 7.48148 10.233 5.20068L2.5002 6.74728L0.041748 9.20568L1.27095 10.4349H3.72941Z",
  fill: "currentColor"
});

var SvgDiscoverIcon = function SvgDiscoverIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDiscoverIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/discover_icon.0f296a98.svg";
export { ForwardRef as ReactComponent };